import { HttpClient } from '@angular/common/http';
import { SendCoin } from '@app/shared/models/coin';
import { Coin, Task } from '@app/shared/models/coin-management.model';
import { ResponseObject } from '@app/shared/models/response';
import { Observable, of } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

export class CoinManagementApi {
  apiUrl = 'https://dummyjson.com';

  constructor(public readonly http: HttpClient) {}

  // mock data
  getTasks(): Observable<Task[]> {
    const data = localStorage.getItem('task-of-user');
    if (data) {
      return of(JSON.parse(data));
    } else {
      return this.http.get<ResponseObject>('assets/mock/task-list.json').pipe(
        retry(1),
        map(res => {
          if (res.success) {
            // TODO: remove when we have API for coin management
            localStorage.setItem('task-of-user', JSON.stringify(res.data));
            return res.data;
          }
        }),
        catchError(error => {
          throw error.error;
        })
      );
    }
  }

  deleteTask(taskId: string): Observable<ResponseObject> {
    const storedData = localStorage.getItem('task-of-user');
    let taskList: Task[] = [];
    // TODO: remove when we have API for coin management
    if (storedData) {
      taskList = JSON.parse(storedData);
      const taskIndex = taskList.findIndex(item => item.id === taskId);
      if (taskIndex !== -1) {
        taskList.splice(taskIndex, 1);
        localStorage.setItem('task-of-user', JSON.stringify(taskList));
      }
    }
    return this.http.delete<ResponseObject>(this.apiUrl + '/todos/' + taskId).pipe(
      retry(1),
      catchError(error => {
        throw error.error;
      })
    );
  }

  updateTask(task: Task): Observable<Task> {
    const storedData = localStorage.getItem('task-of-user');
    let taskList: Task[] = [];
    if (storedData) {
      // TODO: remove when we have API for coin management
      taskList = JSON.parse(storedData);
      const taskIndex = taskList.findIndex(item => item.id === task.id);
      if (taskIndex !== -1) {
        taskList[taskIndex] = task;
        localStorage.setItem('task-of-user', JSON.stringify(taskList));
      }
    }
    return this.http
      .put<ResponseObject>(this.apiUrl + '/todos/' + task.id, JSON.stringify(task))
      .pipe(
        retry(1),
        map(() => task),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getCoin(): Observable<number> {
    return this.http.get<ResponseObject>('assets/mock/coin.json').pipe(
      retry(1),
      map(res => {
        // TODO: remove when we have API for coin management
        const storedCoin = localStorage.getItem('coin');
        if (!storedCoin) {
          localStorage.setItem('coin', JSON.stringify(res.data.coin));
          return res.data.coin;
        }
        return JSON.parse(storedCoin);
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  claimCoins(data: Coin): Observable<ResponseObject> {
    return this.http.put<ResponseObject>(this.apiUrl + '/todos/1', JSON.stringify(data)).pipe(
      map(res => {
        // TODO: remove when we have API for coin management
        const coin = localStorage.getItem('coin');
        if (coin) {
          let dataFormat = JSON.parse(coin);
          dataFormat = dataFormat + data.reward;
          localStorage.setItem('coin', JSON.stringify(dataFormat));
        }
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  sendCoins(data: SendCoin): Observable<ResponseObject> {
    return this.http.put<ResponseObject>(this.apiUrl + '/todos/1', JSON.stringify(data)).pipe(
      map(res => {
        if (res.success) {
          // TODO : delete after handling API
          const coin = localStorage.getItem('coin');
          if (coin) {
            let dataFormat = JSON.parse(coin);
            dataFormat = dataFormat - data.coin;
            localStorage.setItem('coin', JSON.stringify(dataFormat));
          }
        }
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }
}
